var _desc, _defs, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path2, _path3, _path4, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineProgramTestAttempts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Online program test attempts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A laptop displaying a completed test with a score badge.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenGradient",
    x1: 72,
    y1: 77,
    x2: 278,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89f1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f17067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "badgeGradient",
    x1: 220,
    y1: 116,
    x2: 292,
    y2: 188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cc68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f9d6b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 65,
    width: 272,
    height: 184,
    rx: 12,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299 253H51c-10 0-18-8-18-18V79c0-10 8-18 18-18h248c10 0 18 8 18 18v156c0 10-8 18-18 18ZM51 73c-3 0-6 3-6 6v156c0 3 3 6 6 6h248c3 0 6-3 6-6V79c0-3-3-6-6-6H51Z",
    fill: "#8f9699"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 87,
    width: 232,
    height: 136,
    rx: 8,
    fill: "url(#screenGradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 111,
    width: 112,
    height: 14,
    rx: 7,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 142,
    width: 132,
    height: 10,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.78
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 168,
    width: 111,
    height: 10,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.78
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 194,
    width: 88,
    height: 10,
    rx: 5,
    fill: "#ffffff",
    opacity: 0.78
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 151,
    r: 42,
    fill: "url(#badgeGradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m227 151 11 12 25-28",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 249h332v29c0 7-6 13-13 13H22c-7 0-13-6-13-13v-29Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328 295H22c-9 0-17-8-17-17v-33h132v7c0 2 2 4 4 4h68c2 0 4-2 4-4v-7h132v33c0 9-8 17-17 17ZM17 257v21c0 3 2 5 5 5h306c3 0 5-2 5-5v-21H225c-2 7-8 11-16 11h-68c-8 0-14-4-16-11H17Z",
    fill: "#8f9699"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 276,
    width: 94,
    height: 8,
    rx: 4,
    fill: "#c7cbcd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineProgramTestAttempts);
export default __webpack_public_path__ + "static/media/OnlineProgramTestAttempts.9d46b07af4461a2b94da86fe86fb1e7d.svg";
export { ForwardRef as ReactComponent };